"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableFooter_1 = __importDefault(require("@mui/material/TableFooter"));
const core_1 = require("components/QCurrency/core");
const utils_1 = require("utils/utils");
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const selectors_1 = require("data/transactions/selectors");
const TableHeader_1 = __importDefault(require("./TableHeader"));
const TableTxnRow_1 = __importDefault(require("./TableTxnRow"));
const styles_1 = require("../../styles");
const isIe = require('is-iexplorer') || (0, utils_1.isOldEdge)(); // eslint-disable-line
const useStyles = (0, mui_1.makeStyles)()(styles_1.calendarTxnModalStyles);
const tableColumns = Object.freeze({
    reminderCol: {
        label: '',
    },
    payeeCol: {
        label: 'Payee',
    },
    accountCol: {
        label: 'Account',
    },
    categoryCol: {
        label: 'Category',
    },
    amountCol: {
        label: 'Amount',
    },
    optionsCol: {
        label: '',
    },
});
const CalTxnsModal = (props) => {
    const { classes } = useStyles();
    const { onClose, date, txns, onGoToRegister, onGoToBills, useDashboardPrefFilter } = props;
    const filterCalendarTxnList = useDashboardPrefFilter ? selectors_1.filterDashboardCalendarTxnBasedOnPref : selectors_1.filterCalendarTxnBasedOnPreferences;
    const filteredTxnList = (0, react_redux_1.useSelector)((state) => filterCalendarTxnList(state, { txnList: txns }));
    const modalTitle = (0, react_1.useMemo)(() => <div className={classes.modalTitle}>{date}</div>, [date, classes]);
    const txnsTotal = (0, react_1.useMemo)(() => filteredTxnList &&
        filteredTxnList.reduce((acc, txn) => { var _a; return acc + parseFloat((_a = txn.amount) !== null && _a !== void 0 ? _a : 0); }, 0), [filteredTxnList]);
    const onCloseHandler = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        if (onClose)
            onClose();
    }, [onClose]);
    const onHandleModalClick = (0, react_1.useCallback)((event) => event.stopPropagation(), []);
    const tableContent = (0, react_1.useMemo)(() => ((filteredTxnList === null || filteredTxnList === void 0 ? void 0 : filteredTxnList.size) ? (<TableContainer_1.default className={classes.tableContainer}>
        <Table_1.default stickyHeader padding="none" size="small">
          <TableHeader_1.default columns={tableColumns} classes={classes}/>
          <TableBody_1.default>
            {filteredTxnList.map((txn) => <TableTxnRow_1.default key={`row-${txn.id}`} columns={tableColumns} classes={classes} txn={txn} onGoToRegister={onGoToRegister} onGoToBills={onGoToBills}/>)}
          </TableBody_1.default>
        </Table_1.default>
        <Table_1.default padding="none" size="small" className={classes.footerTable}>
          <TableFooter_1.default>
            <TableRow_1.default>
              <TableCell_1.default className={classes.reminderCol}/>
              <TableCell_1.default className={classes.totalLabelCell}>
                <div className={classes.cellContainer}>Total</div>
              </TableCell_1.default>
              <TableCell_1.default className={classes.totalAmountCell}>
                <div className={classes.cellContainer}>{(0, core_1.formatAmount)(txnsTotal)}</div>
              </TableCell_1.default>
            </TableRow_1.default>
          </TableFooter_1.default>
        </Table_1.default>
      </TableContainer_1.default>) : <div className={classes.noTransactions}>No Transactions</div>), [classes, filteredTxnList, txnsTotal, onGoToBills, onGoToRegister]);
    return (<StdDialog_1.default open classes={isIe ? { paper: classes.dialogPaper } : {}} onClose={onCloseHandler} title={modalTitle} maxWidth="xlg" onClick={onHandleModalClick}>
      <DialogContent_1.default sx={{ padding: '0 !important' }}>
        {tableContent}
      </DialogContent_1.default>
      <div className={classes.buttonArea}>
        <Button_1.default color="primary" onClick={onCloseHandler} id="txn-modal-done">
          Done
        </Button_1.default>
      </div>

    </StdDialog_1.default>);
};
exports.default = react_1.default.memo(CalTxnsModal);
